var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#151515"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.32 16.755a5.672 5.672 0 0 1 0 8.059l-2.535 2.52c-2.236 2.222-5.873 2.221-8.108 0a5.68 5.68 0 0 1 0-8.06l1.4-1.39c.37-.37 1.01-.125 1.029.397.024.664.144 1.332.365 1.976a.6.6 0 0 1-.142.623l-.494.49c-1.057 1.052-1.09 2.762-.044 3.823a2.73 2.73 0 0 0 3.86.02l2.535-2.52a2.687 2.687 0 0 0-.39-4.139.603.603 0 0 1-.262-.472 1.488 1.488 0 0 1 .441-1.118l.794-.79a.609.609 0 0 1 .777-.064c.276.192.535.408.774.645Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.323 11.666c-2.235-2.221-5.872-2.222-8.108 0l-2.535 2.52-.013.014a5.672 5.672 0 0 0 .013 8.045c.239.237.498.453.774.645a.609.609 0 0 0 .777-.065l.794-.79c.315-.312.456-.72.441-1.117a.598.598 0 0 0-.262-.472 2.687 2.687 0 0 1-.39-4.139l2.535-2.52a2.73 2.73 0 0 1 3.86.02c1.046 1.06 1.013 2.771-.044 3.822l-.494.49a.6.6 0 0 0-.142.624c.22.644.34 1.312.365 1.976.02.522.659.767 1.03.398l1.4-1.391a5.68 5.68 0 0 0 0-8.06Z",
    fill: "#151515"
  })));
};
export default SvgCopy;